import React from 'react';
import './Sidebar.scss';

interface Props {
  children: any;
  duration: number;
  className?: string;
  state: string;
}

const Sidebar = ({ children, duration, state, className }: Props) => {
  const defaultStyle = {
    transition: `transform ${duration}ms ease-in-out`,
    transform: 'translateX(101%)',
  };

  const transitionStyles = {
    entering: { transform: 'translateX(101%)' },
    entered: { transform: 'translateX(0)' },
  };
  return (
    <div
      className={'sidebar ' + className}
      style={{
        ...defaultStyle,
        ...transitionStyles[state],
      }}
    >
      {children}
    </div>
  );
};

export default Sidebar;
